<ion-app>

  <ion-split-pane contentId="main" when="md">
    <ion-menu contentId="main" id="menu" persistent=true swipeGesture="false" [disabled]="disableMenu" (ionDidOpen)="menuOpened()"
      [type]="platformServ.getPlatform() === 'desktop' ? 'reveal' : 'overlay'">


      <div>
        <div class="menu-close" (click)="menu.close()">
          <ion-icon name="close-outline" role="img" class="md hydrated" aria-label="close outline"></ion-icon>
        </div>

        <div class="user-ios user-initials ion-padding">
          <div class="iniciales">{{ user?.initials || '--' }}</div>
        </div>
        <div class="user-ios user-name ion-text-center">{{ user?.name || '--' }}</div>
        <div class="user-ios version-name ion-text-center">{{ 'app-component.Versión'  | translate }}
          {{ version || '--'}}</div>

          <div *ngIf="message === 'testing'" class="user-ios version-name ion-text-center">{{versionSelected? versionSelected : 'master'}}</div>

        <ion-list lines="none" class="ion-padding-top ion-margin-top">
          <ion-menu-toggle auto-hide="false">
            <ng-container *ngFor="let p of appPages; let i =index">
              <ion-item *ngIf="p.url !== '/email-validation'" class="clickable" [ngClass]="{'active-route': p.active}"
                [routerDirection]="'root'" (click)="activateRoute(i)">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label>
                  {{p.title}}
                </ion-label>
              </ion-item>
              <ion-item *ngIf="p.url === '/email-validation'" class="clickable" [ngClass]="{'active-route': p.active}"
                [routerDirection]="'root'" (click)="activateRoute(i)">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label>
                  {{p.title}}
                  <ion-badge class="email-validation" color="danger">
                    <div></div>
                  </ion-badge>
                </ion-label>
              </ion-item>
            </ng-container>
          </ion-menu-toggle>
        </ion-list>

        <div (click)="ccloudPage()" class="ion-text-center credits clickable">
          <p>{{ 'app-component.Con la tecnología de'  | translate }} <span class="ccloud">Calidad Cloud
              S.A.</span></p>
        </div>

      </div>

    </ion-menu>

    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>